// @mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
// theme
import { hideScroll } from "src/theme/css";
// hooks
import { useUser } from "src/auth/hooks";
import { NavSectionMini } from "src/components/nav-section";
//
import { Link } from "@mui/material";
import { LogoSlim } from "src/components/logo/slim";
import { RouterLink } from "src/routes/components";
import { NavToggleButton } from "../_common";
import { NAV } from "../config-layout";
import { useNavData } from "./config-navigation";

// ----------------------------------------------------------------------

export default function NavMini() {
  const user = useUser();

  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: "fixed",
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Link component={RouterLink} href="/">
          <Box sx={{ mt: 3, mb: 1, mx: "auto" }}>
            <LogoSlim isCollapsed={true} />
          </Box>
        </Link>

        <NavSectionMini
          data={navData}
          config={{
            currentRole: "",
          }}
        />
      </Stack>
    </Box>
  );
}
